import React from "react";
import classNames from "classnames";

import FilterIcon from "@material-ui/icons/Filter";
import InfoIcon from "@material-ui/icons/Info";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import PagesIcon from "@material-ui/icons/Pages";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import InfinityIcon from "@material-ui/icons/AllInclusive";
import BarChartIcon from "@material-ui/icons/InsertChartOutlined";
import SolidIcon from "@material-ui/icons/Brightness1";
import { makeStyles, ListItem, Tooltip, IconButton, Badge } from "@material-ui/core";

import { useOfflineAssets } from '../../../offline/useOfflineAssets'
import { DrawerContent } from "../../../../entities/DrawerContent";
import { useEditor } from "../../editor/useEditor";
import { useBuilderDrawer } from "../../drawer/useBuilderDrawer";
import { RocketLaunchIcon } from "../../../../components/RocketLaunchIcon";

const useStyles = makeStyles((theme) => ({
	slidesIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#801d66",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#801d66",
			backgroundColor: "#801d662e",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
			borderStyle: "none"
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	slidesIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#801d66",
		border: "1px solid #801d66",
		backgroundColor: "#801d662e",
	},
	assistantIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#4067CA",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#4067CA",
			backgroundColor: "#4067CA2E",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
			borderStyle: "none"
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	assistantIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#4067CA",
		border: "1px solid #4067CA",
		backgroundColor: "#4067CA2E",
	},
	bibleIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#027172",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#027172",
			backgroundColor: "#0271722e",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
			borderStyle: "none"
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	bibleIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#027172",
		border: "1px solid #027172",
		backgroundColor: "#0271722e",
	},
	detailIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#767676",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#767676",
			backgroundColor: "#7676762e",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
			borderStyle: "none"
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	detailIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#767676",
		border: "1px solid #767676",
		backgroundColor: "#7676762e",
	},
	illustrationIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#961617",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#961617",
			backgroundColor: "#9616172e",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	illustrationIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#961617",
		border: "1px solid #961617",
		backgroundColor: "#9616172e",
	},
	sermonIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#f26321",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#f26321",
			backgroundColor: "#f263212e",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
			borderStyle: "none"
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	sermonIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#f26321",
		border: "1px solid #f26321",
		backgroundColor: "#f263212e",
	},
	geniusIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#9E70C1",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#9E70C1",
			backgroundColor: "#9E70C12e",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
			borderStyle: "none"
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	geniusIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#9E70C1",
		border: "1px solid #9E70C1",
		backgroundColor: "#9E70C12e",
	},
	geniusBadge: {
		backgroundColor: "lime",
		marginRight: 25,
		[theme.breakpoints.up("md")]: {
			marginRight: "30px",
			marginTop: "-7px",
		},
	},
	analyzerIcon: {
		color: "#fff",
		border: "1px solid #fff",
		backgroundColor: "#02376b",
		transition: "all 0.3s ease 0s",
		"&:hover": {
			transition: "all 0.3s ease 0s",
			color: "#02376b",
			backgroundColor: "#02376b2e",
		},
		"&:disabled": {
			color: "rgba(0, 0, 0, 0.26)",
			backgroundColor: "rgba(0, 0, 0, 0.12)",
			borderStyle: "none"
		},
		[theme.breakpoints.down("sm")]: {
			padding: 5,
		},
	},
	analyzerIconActive: {
		transition: "all 0.3s ease 0s",
		color: "#02376b",
		border: "1px solid #02376b",
		backgroundColor: "#02376b2e",
	},
	badge: {
		marginRight: 25,
		[theme.breakpoints.up("md")]: {
			marginRight: "30px",
			marginTop: "-7px",
		},
	},
	listItem: {
		paddingRight: theme.spacing(1),
		paddingLeft: theme.spacing(1),
	},
}));

export function BuilderAppIconListItems() {
	const classes = useStyles();
	const editor = useEditor();
	const slideLength = editor.slides.length;

	const {onlineMode} = useOfflineAssets();

	const builderDrawer = useBuilderDrawer();
	const { drawerContent, showGeniusBadge } = builderDrawer;
	const { onMainDrawerChange } = builderDrawer;

	return (
		<>
			<ListItem dense className={classes.listItem} >
				<Tooltip 
					placement="left" 
					title="Details"
					className={classNames(classes.detailIcon, (drawerContent === DrawerContent.Details && onlineMode) && classes.detailIconActive)}
				>
					<IconButton
						color="primary"
						onClick={() => onMainDrawerChange(true, DrawerContent.Details)}
						disabled={!onlineMode}
					>
						<InfoIcon fontSize="inherit" />
					</IconButton>
				</Tooltip>
			</ListItem>
			<ListItem dense className={classes.listItem} >
				<Tooltip 
					placement="left" 
					className={classNames(classes.slidesIcon, (drawerContent === DrawerContent.Slides && onlineMode) && classes.slidesIconActive)}
					title={`${slideLength > 0 ? slideLength : ""} Slide${slideLength > 1 ? "s" : ""}`}
				>
					<IconButton onClick={() => 
						onMainDrawerChange(true, DrawerContent.Slides)}
						disabled={!onlineMode}
					>
						{slideLength > 0  && onlineMode? (
							<Badge
								classes={{
									badge: classes.badge,
								}}
								color="primary"
								badgeContent={slideLength}
							>
								<FilterIcon />
							</Badge>
						) : (
							<FilterIcon />
						)}
					</IconButton>
				</Tooltip>
			</ListItem>
			<ListItem dense className={classes.listItem}>
				<Tooltip 
					placement="left" 
					className={classNames(classes.assistantIcon, (drawerContent === DrawerContent.Assistant && onlineMode) && classes.assistantIconActive)}
					title="AI Assistant"
				>
					<IconButton onClick={() => 
						onMainDrawerChange(true, DrawerContent.Assistant)}
						disabled={!onlineMode}
					>
						<RocketLaunchIcon />
					</IconButton>
				</Tooltip>
			</ListItem>
			<ListItem dense className={classes.listItem}>
				<Tooltip placement="left" title="Search Bible" className={classNames(classes.bibleIcon, (drawerContent === DrawerContent.Bible && onlineMode) && classes.bibleIconActive)}>
					<IconButton  
						disabled={!onlineMode}
						onClick={() => onMainDrawerChange(true, DrawerContent.Bible)}>
						<ImportContactsIcon fontSize="inherit" />
					</IconButton>
				</Tooltip>
			</ListItem>
			<ListItem dense className={classes.listItem}>
				<Tooltip
					placement="left"
					title="Search Sermons"
					className={classNames(classes.sermonIcon, (drawerContent === DrawerContent.Sermon && onlineMode) && classes.sermonIconActive)}
				>
					<IconButton 
					 	onClick={() => onMainDrawerChange(true, DrawerContent.Sermon)} 
					 	disabled={!onlineMode}
					>
						<LibraryBooksIcon fontSize="inherit" />
					</IconButton>
				</Tooltip>
			</ListItem>
			<ListItem dense className={classes.listItem} >
				<Tooltip
					placement="left"
					title="Search Illustrations"
					color="primary"
					className={classNames(classes.illustrationIcon, (drawerContent === DrawerContent.Illustration && onlineMode) && classes.illustrationIconActive)}
				>
					<IconButton onClick={() => onMainDrawerChange(true, DrawerContent.Illustration)} disabled={!onlineMode}>
						<PagesIcon fontSize="inherit" />
					</IconButton>
				</Tooltip>
			</ListItem>
			<ListItem dense className={classes.listItem}>
				<Tooltip
					placement="left"
					title="Sermon Genius"
					className={classNames(classes.geniusIcon, (drawerContent === DrawerContent.Genius && onlineMode) && classes.geniusIconActive)}
				>
					<IconButton onClick={() => onMainDrawerChange(true, DrawerContent.Genius)} disabled={!onlineMode} >
						{showGeniusBadge && onlineMode ? (
							<Badge
								classes={{
									badge: classes.geniusBadge,
								}}
								badgeContent={<SolidIcon style={{ fontSize: "10px", color: "white" }} />}
							>
								<InfinityIcon />
							</Badge>
						) : (
							<InfinityIcon />
						)}
					</IconButton>
				</Tooltip>
			</ListItem>
			<ListItem dense className={classes.listItem}>
				<Tooltip
					placement="left"
					title="Sermon Analyzer"
					className={classNames(classes.analyzerIcon, (drawerContent === DrawerContent.Analyzer && onlineMode) && classes.analyzerIconActive)}
				>
					<IconButton  onClick={() => onMainDrawerChange(true, DrawerContent.Analyzer)} disabled={!onlineMode}>
						<BarChartIcon />
					</IconButton>
				</Tooltip>
			</ListItem>
		</>
	);
}